/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=5134e3d8&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=5134e3d8&lang=scss&scoped=true"

import exportComponent from "/Users/kaopuai/rzd-project/rzd-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5134e3d8"]])

export default __exports__